import * as React from 'react';
import { Label } from '@fluentui/react/lib/Label';
import { AuftragStatusLabel } from 'utils/labels';
import { ValueType } from 'react-select';
import { SelectOption } from 'formComponents/Select/types';
import { MultiSelect } from '../Select/MultiSelect';

interface AuftragStatusProps {
    disabled?: boolean;
    value: string[];
    renderLabel?: 'label' | 'placeholder';
    onChange: (newValue: string[]) => void;
}

export const AuftragStatusMulti: React.FC<AuftragStatusProps> = ({
    value,
    disabled = false,
    renderLabel = 'label',
    onChange,
}) => {
    const options = React.useMemo(() => {
        const list: SelectOption[] = [];

        Object.keys(AuftragStatusLabel).forEach((key) => {
            list.push({
                value: key,
                label: AuftragStatusLabel[key],
            });
        });

        return list;
    }, []);

    const selectedOptions = React.useMemo(() => {
        return value.map((v) => ({
            value: v,
            label: AuftragStatusLabel[v] || v,
        }));
    }, [value]);

    return (
        <>
            {renderLabel === 'label' && <Label>Status</Label>}
            <MultiSelect
                name="status"
                isDisabled={disabled}
                value={selectedOptions}
                options={options}
                onChange={(newOptions: ValueType<SelectOption, true>): void => {
                    onChange(((newOptions || []) as SelectOption[]).map((option) => option.value));
                }}
                placeholder={renderLabel === 'placeholder' ? 'Status' : ''}
            />
        </>
    );
};
